import { FormGroup } from "@blueprintjs/core";
import { DateRangeInput2 } from "@blueprintjs/datetime2";
import { FormFieldErrorContainer } from "../../CoreFields/FieldError/FormFieldErrorContainer";
import { FieldLabel } from "../../CoreFields/FieldLabel/FieldLabel";
import { DateRangeProps, FieldLabeledProps } from "../../types/fieldTypes";
import { useDateRangeField } from "./useDateRangeField";

/** Date Range Field Properties */
export interface DateRangeFieldProps extends DateRangeProps {
  minDate?: Date;
  maxDate?: Date;
  /** Configure display of shortcuts in date picker: Enable, Disable, or Custom*/
  shortcuts?: boolean | DateRangeShortCutProps[];
  allowSingleDayRange?: boolean;
  labelProps?: FieldLabeledProps;
}

/** Use to configure any custom date range shortcuts in the shortcut property */
export interface DateRangeShortCutProps {
  dateRange: [Date | null, Date | null];
  includeTime?: boolean;
  label: string;
}

const DateRangeField: React.FC<DateRangeFieldProps> = (props) => {
  const { localDates, setLocalDates, formatDate, parseDate } =
    useDateRangeField(props);

  return (
    <div className="ucl-base-input-date-range-field-container">
      <FormGroup
        className={`${
          props.isRequired &&
          (!localDates || localDates.some((x) => x === null))
            ? "has-required-background"
            : "base-field"
        }`}
      >
        {props.label && (
          <FieldLabel
            labelName={props.label}
            tooltipDescription={props.description}
            fieldProps={{ ...props, value: localDates }}
            isRequired={props.isRequired}
            {...props.labelProps}
          />
        )}
        <DateRangeInput2
          value={localDates}
          placeholder="MM/DD/YYYY"
          closeOnSelection
          formatDate={formatDate}
          parseDate={parseDate}
          onChange={(date) => {
            setLocalDates(date);
            props.onSubmit && props.onSubmit(!date ? undefined : date);
          }}
          disabled={props.disabled}
          minDate={props.minDate || new Date("1900-01-01 05:00:00")}
          maxDate={props.maxDate}
          shortcuts={props.shortcuts}
          allowSingleDayRange={props.allowSingleDayRange}
        />
        {props.errorMessages && (
          <FormFieldErrorContainer errorMessages={props.errorMessages} />
        )}
      </FormGroup>
    </div>
  );
};

export default DateRangeField;
